export class OfflineError extends Error {
  constructor(url: string) {
    super(`Network is offline. Could not send request to: ${url}`);
    this.name = 'OfflineError';
  }
}
